import { USER_DETAIL_FAIL, USER_DETAIL_REQUEST, USER_DETAIL_SUCCESS, USER_LIST_FAIL, USER_LIST_REQUEST, USER_LIST_SUCCESS } from "../constats/user.constat";

export const userDetailReducer = (state={},action) => {
    switch (action.type) {
        case USER_DETAIL_REQUEST:
            return {
                loading: true
            };
        case USER_DETAIL_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        case USER_DETAIL_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        default:
            return state;
    }
} 

export const userListReducer = (state={},action) => {
    switch (action.type) {
        case USER_LIST_REQUEST:
            return {
                loading: true
            };
        case USER_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            }
        case USER_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        default:
            return state;
    }
} 